// @flow

import React from 'react';

export const SubmittingContext = React.createContext<?boolean>(null);
